export const architectureAndUrbanPlanningConst = {
  path: "/single-programs/architecture-and-urban-planning",
  title: "ФАКУЛЬТЕТ ИСКУССТВА И ТЕХНОЛОГИЙ – АРХИТЕКТУРА И ГРАДОСТРОИТЕЛЬСТВО",
  contentJSX: (
    <>
      <p>
        <strong>Диплом:</strong> бакалавра / магистра
      </p>
      <p>
        <strong>Формы обучения:</strong> очно или дистанционно
      </p>
      <p>
        <strong>Форма связи:</strong> Получить консультацию приемной комиссии
      </p>
      <h2>Архитектура и градостроительство — это искусство формировать будущее</h2>
      <p>
        Архитектура — это больше, чем проектирование зданий. Это синтез эстетики, технологии, устойчивости и культуры. В рамках этой
        программы вы научитесь создавать не просто конструкции, а жизненные пространства, в которых комфортно и безопасно жить.
      </p>
      <p>
        Программа ориентирована на развитие как художественного вкуса, так и инженерных навыков. Вы будете проектировать не только дома и
        сооружения, но и городские пространства, влияющие на качество жизни миллионов людей.
      </p>
      <h2>Что вы будете изучать?</h2>
      <ul>
        <li>Архитектурное проектирование и моделирование</li>
        <li>История и теория архитектуры</li>
        <li>Градостроительное планирование</li>
        <li>Компьютерное моделирование (AutoCAD, Revit, BIM)</li>
        <li>Устойчивое и экологичное строительство</li>
        <li>Урбанистика и социология городской среды</li>
        <li>Ландшафтная архитектура</li>
        <li>Правовые и нормативные основы проектирования</li>
      </ul>
      <p>Программа включает практические воркшопы, стажировки в архитектурных бюро и участие в международных конкурсах.</p>
      <h2>Кем можно работать после окончания?</h2>
      <ul>
        <li>Архитектор в частной или государственной компании</li>
        <li>Градостроитель и специалист по пространственному развитию</li>
        <li>Урбан-дизайнер и консультант по благоустройству</li>
        <li>Архитектор-дизайнер в международных проектах</li>
        <li>Эксперт в сфере устойчивой архитектуры и «умных городов»</li>
        <li>Академическая и исследовательская деятельность</li>
      </ul>
      <h2>Зарплата в Европе:</h2>
      <p>
        от <strong>€55,000 до €100,000 в год</strong>
      </p>
      <h2>Почему выбирают нас?</h2>
      <ul>
        <li>Европейский диплом, признанный во многих странах</li>
        <li>Возможность учёбы дистанционно или очно</li>
        <li>Участие в реальных проектах с первого курса</li>
        <li>Стажировки в архитектурных бюро Европы</li>
        <li>Индивидуальное наставничество от преподавателей-практиков</li>
        <li>Обучение на русском или английском языке</li>
      </ul>
      <h2>Образование, которое строит будущее</h2>
      <p>
        Наши выпускники создают современные кампусы, экологичные жилые кварталы и общественные пространства, которые получают международные
        награды за инновации и устойчивость.
      </p>
      <br />
      <p>«Архитектура — это язык, на котором говорит город. Мы учим этому языку с первого дня.»</p>
      <br />
      <h2>Как поступить?</h2>
      <p>
        Поступить на программу легко — приёмная комиссия поможет с оформлением всех документов. Мы сопровождаем вас от заявки до первого дня
        учёбы.
      </p>
    </>
  ),
  contentSearch: `
    Диплом: бакалавра / магистра
    Формы обучения: очно или дистанционно
    Форма связи: Получить консультацию приемной комиссии
    Архитектура и градостроительство — это искусство формировать будущее
    Архитектура — это больше, чем проектирование зданий. Это синтез эстетики, технологии, устойчивости и культуры. В рамках этой программы вы научитесь создавать не просто конструкции, а жизненные пространства, в которых комфортно и безопасно жить.
    Программа ориентирована на развитие как художественного вкуса, так и инженерных навыков. Вы будете проектировать не только дома и сооружения, но и городские пространства, влияющие на качество жизни миллионов людей.
    Что вы будете изучать?
    • Архитектурное проектирование и моделирование
    • История и теория архитектуры
    • Градостроительное планирование
    • Компьютерное моделирование (AutoCAD, Revit, BIM)
    • Устойчивое и экологичное строительство
    • Урбанистика и социология городской среды
    • Ландшафтная архитектура
    • Правовые и нормативные основы проектирования
    Программа включает практические воркшопы, стажировки в архитектурных бюро и участие в международных конкурсах.
    Кем можно работать после окончания?
    • Архитектор в частной или государственной компании
    • Градостроитель и специалист по пространственному развитию
    • Урбан-дизайнер и консультант по благоустройству
    • Архитектор-дизайнер в международных проектах
    • Эксперт в сфере устойчивой архитектуры и «умных городов»
    • Академическая и исследовательская деятельность
    Зарплата в Европе: от €55,000 до €100,000 в год
    Почему выбирают нас?
    • Европейский диплом, признанный во многих странах
    • Возможность учёбы дистанционно или очно
    • Участие в реальных проектах с первого курса
    • Стажировки в архитектурных бюро Европы
    • Индивидуальное наставничество от преподавателей-практиков
    • Обучение на русском или английском языке
    Образование, которое строит будущее
    Наши выпускники создают современные кампусы, экологичные жилые кварталы и общественные пространства, которые получают международные награды за инновации и устойчивость.
    «Архитектура — это язык, на котором говорит город. Мы учим этому языку с первого дня.»

    Как поступить?Поступить на программу легко — приёмная комиссия поможет с оформлением всех документов. Мы сопровождаем вас от заявки до первого дня учёбы.
  `,
};
